export enum TARIFF_TYPES {
  ENERGY = "energy-fixed",
  SPOT = "spot-standard",
}

export const locales = ["en", "fi"];
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "fi";
export const localeNames: Record<Locale, string> = {
  en: "English",
  fi: "Suomi",
};
export const authLocaleNames: Record<Locale, string> = {
  en: "EN",
  fi: "FI",
};

// COUNTRIES
export const countries = ["FIN"] as const;
export type Countries = (typeof countries)[number];
export const defaultCountry: Countries = "FIN";
export const CountryNames: Record<Countries, string> = {
  FIN: "Finland",
};

// CURRENCIES
export const currencies = ["EUR"] as const;
export type Currency = (typeof currencies)[number];
export const defaultCurrency: Currency = "EUR";
export const CurrencyNames: Record<Currency, string> = {
  EUR: "EUR",
};

// TIMEZONES
export const timezones = ["Europe/Helsinki"] as const;
export type Timezone = (typeof timezones)[number];
export const defaultTimezone: Timezone = "Europe/Helsinki";
export const TimezoneNames: Record<Timezone, string> = {
  "Europe/Helsinki": "Europe/Helsinki",
};

export enum Roles {
  OWNER = "org:owner",
  ADMIN = "org:admin",
  MANAGER = "org:manager",
  MEMBER = "org:member",
}

export type Role = keyof typeof Roles;

export const documentLocales = ["en", "fi"] as const;
export type DocumentLocale = (typeof documentLocales)[number];
export const defaultDocumentLocale: DocumentLocale = "fi";
export const DocumentLocaleNames: Record<DocumentLocale, string> = {
  en: "English",
  fi: "Suomi",
};

export const invoicingTypes = ["email", "einvoice"] as const;
export type InvoicingType = (typeof invoicingTypes)[number];
export const defaultInvoicingType = "einvoice";

export const defaultNetPaymentTerm = 14;
export const defaultOperatorMarginEuros = 0.02;

export const plugTypes = ["CCS", "CHAdeMO", "schuko", "type2"] as const;
export type SocketPlugType = (typeof plugTypes)[number];

export const defaultSocketType = "type2";

export const orgTypes = ["real-estate", "fleet"] as const;
export type OrgType = (typeof orgTypes)[number];

export enum RenterType {
  SITE = "Site",
  ORGANIZATION = "Organization",
  DRIVER = "Driver",
}
export enum PayerType {
  SITE = "Site",
  ORGANIZATION = "Organization",
  DRIVER = "Driver",
}

export enum PayoutType {
  BUSINESS = "business",
  PERSON = "person",
}

export const payoutTypes = Object.values(PayoutType) as [
  PayoutType,
  ...PayoutType[],
];
export const defaultPayoutType = PayoutType.BUSINESS;

export enum ChargerLabel {
  SERVICING_DEVICE = "servicing_device",
  UNDER_MAINTENANCE = "under_maintenance",
  RENTAL_DEVICE = "rental_device",
}

export const chargerLabels = Object.values(ChargerLabel) as [
  ChargerLabel,
  ...ChargerLabel[],
];

export enum Tags {
  DefaultTag = "defaultTag",
}

const appStage = process.env.NEXT_PUBLIC_APP_STAGE;
export const eMablerBaseUrl =
  appStage === "prod"
    ? "https://connect.emabler.io"
    : "https://test.connect.emabler.net";

export const DAYS = [
  { value: 0, label: "Mon" },
  { value: 1, label: "Tue" },
  { value: 2, label: "Wed" },
  { value: 3, label: "Thu" },
  { value: 4, label: "Fri" },
  { value: 5, label: "Sat" },
  { value: 6, label: "Sun" },
];
